export function hasShippingLabels(courierId) {
  if (courierId === "swisspost") return false;
  if (courierId === "ware2go") return false;
  if (courierId === "byrd") return false;
  if (courierId === "planzer") return false;
  return true;
}

export function hasDeliveryInstructionsCapability(courierId) {
  if (courierId === "gls") return true;
  if (courierId === "parcelforce") return true;
  if (courierId === "royal_mail") return true;
  if (courierId === "hallstein") return true;
  if (courierId === "planzer") return true;
  return false;
}

export function hasIndividualPackageHandlingCapability(courierId) {
  if (courierId === "gls") return true;
  if (courierId === "parcelforce") return true;
  if (courierId === "royal_mail") return true;
  if (courierId === "swisspost") return true;
  if (courierId === "byrd") return true;
  if (courierId === "ware2go") return true;
  if (courierId === "planzer") return true;
  return false;
}

export function getTrackingNrField(courierId) {
  if (courierId === "ups") return "trackingId";
  if (courierId === "ups_v2") return "trackingId";
  return "trackingNr";
}